import PropTypes from 'prop-types';

export const TripType = Object.freeze({
    ROUND_TRIP: 'roundTrip',
    ONE_WAY: 'oneWayTrip',
    MULTIPLE: 'multipleTrip',
});

export const TripTypeCMS = Object.freeze({
    [TripType.ROUND_TRIP]: 'citySearch.hint.round_trip',
    [TripType.ONE_WAY]: 'citySearch.hint.one_way',
    [TripType.MULTIPLE]: 'citySearch.hint.multiple',
});

export const TripTypeShort = Object.freeze({
    R: TripType.ROUND_TRIP,
    O: TripType.ONE_WAY,
    M: TripType.MULTIPLE,
});

export const TripTypeProp = PropTypes.oneOf(Object.values(TripType));
export const TripTypePropDefault = TripType.ROUND_TRIP;

export const getCMSTripTypes = () => {
    return TripTypeCMS;
};
